<div class="row">
  <div class="col-12 table-responsive mb-5">
    <table class="table table-hover order-table">
      <thead>
        <tr>
          <th>
            {{ "DCO.Attachment_Type" | translate }}
          </th>
          <th>
            {{ "DCO.Attachment_Name" | translate }}
          </th>
          <th class="text-center">
            {{ "DCO.Attachment_Download" | translate }}
          </th>
          <th>
            {{ "DCO.Attachment_Date" | translate }}
          </th>
        </tr>
      </thead>
      <ng-template #empty>
        <td colspan="5">
          <div class="alert alert-info"><span class="fw-semibold">{{"DCO.Attachment_NoDocuments" |
              translate}}</span></div>
        </td>
      </ng-template>
      <tbody>
        <ng-container *ngIf="attachedFilesInfo.length > 0; else empty">
          <tr *ngFor="
              let attachment of attachedFilesInfo| paginate : { itemsPerPage: 5, currentPage: page }; index as i
            ">
            <td>
              {{ 'DCO.Attachment_Type_'+attachment.documentType | translate }}
            </td>
            <td>
              {{ attachment.name }}
            </td>
            <td class="text-center">
              <button class="btn btn-link"
                (click)="DownloadAttachment(attachment.attachedFileID)">
                <i class="fas fa-download text-primary fa-lg"
                  title="{{'DCO.Attachment_Download' | translate}}"></i>
              </button>
            </td>
            <td>
              {{ attachment.created | date: currentFormats?.date }}
            </td>
        </ng-container>
      </tbody>
    </table>
    <div class="text-center"
      *ngIf="attachedFilesInfo.length > 0">
      <pagination-controls (pageChange)="page = $event"></pagination-controls>
    </div>
  </div>
</div>
<div class="row">
  <div class="d-flex flex-row-reverse">
    <ng-container *ngIf="stateTransitionsRes.length>0; else confirmTransition">
      <ng-container *ngFor="let button of stateTransitionsRes; index as i">
        <button class="btn"
          [ngClass]="GetButtonClass(button)"
          (click)="ClickActionButton(button, i)">
          <!--<i class="fas fa-check-circle"></i>&nbsp;-->
          {{ 'DCO.State_FinalStatus_' + button.state_FinalStatus +'_button' | translate }}
        </button></ng-container>
    </ng-container>
    <ng-template #confirmTransition>
      <div *ngIf="loadingTransitions"
        class="alert alert-info border-alert-ct"><span class="fw-semibold">{{"DCO.DisputesManagement_NoTransition" |
          translate}}</span></div>
    </ng-template>
  </div>
</div>

<!-- MODAL SUBIR ARCHIVO -->
<div class="modal fade"
  id="uploadFileModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="uploadFileModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title mb-0"
          id="uploadFileModalLabel">
          {{ "DCO.Enrollment_SkipSettings" | translate }}
        </h6>
        <button type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <div class="modal-body text-center">
        <i class="fas fa-question-circle fa-3x text-info mb-3"></i>
        <p class="fw-semibold">
          {{ "DCO.Enrollment_SkipStepQuestion" | translate }}
        </p>
      </div>
      <div class="modal-footer text-end">
        <button class="btn btn-outline-primary"
          data-bs-dismiss="modal">
          {{ "DCO.MassiveInformation_Cancel" | translate }}
        </button>
        <button type="button"
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#skipModal">
          {{ "DCO.MassiveInformation_Accept" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- MODAL ACEPTAR DISPUTA TOTAL -->
<div class="modal fade"
  id="confirmModal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title mb-0"
          id="confirmModalLabel">
          {{ modalTitleStateName | translate }}
        </h6>
        <button type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <div class="modal-body text-center">
        <i class="fas fa-question-circle fa-3x text-info mb-3"></i>
        <p class="fw-semibold">
          {{ "DCO.ClaimsClientDocumentation_AcceptTotalDisputeDescription" | translate }}
        </p>
      </div>
      <div class="modal-footer text-end">
        <button class="btn btn-outline-primary"
          data-bs-dismiss="modal">
          {{ "DCO.MassiveInformation_Cancel" | translate }}
        </button>
        <button type="button"
          class="btn btn-primary"
          [disabled]="blockAcceptButton"
          (click)="AcceptDisputeTotal()">
          <ng-container *ngIf="!blockAcceptButton; else spinner">
            {{ "DCO.MassiveInformation_Accept" | translate }}
          </ng-container>
        </button>
      </div>
      <ng-template #spinner>
        <div class="spinner-border spinner-border-sm"></div>
      </ng-template>
      <div *ngIf="showErrorAccept"
        class="mt-3">
        <div class="alert alert-danger"
          *ngFor="let error of listErrorAccept">
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL DOCUMENTOS FALTANTES -->
<div class="modal fade"
  id="missingFiles"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title mb-0">
          {{ "DCO.DisputesManagement_MissingDocuments" | translate }}
        </h6>
        <button type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>
      <div class="modal-body text-center">
        <i class="fas fa-question-circle fa-3x text-info mb-3"></i>
        <p class="fw-semibold text-danger">
          {{ "DCO.DisputesManagement_MissingDocuments" | translate }}
        </p>
      </div>
      <div class="modal-footer text-center">
        <button type="button"
          class="btn btn-primary"
          data-bs-dismiss="modal">
          {{ "DCO.MassiveInformation_Accept" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- MODAL FORMULARIO DINAMICO -->
<div class="modal fade"
  id="modalPop2"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <!-- HEADER con X -->
      <div class="modal-header">
        <h6 class="modal-title mb-0">
          {{ "DCO.Disputes_titleDocumentation" | translate }}
        </h6>
        <!-- Botón de X para cerrar el modal -->
        <button type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="onCancel()">
        </button>
      </div>
      <!-- BODY -->

        <div class="modal-body">
          <div>
            @if (showInternational == "International") {
                <strong>
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription_International_RequiredLanguage" | translate }}:
                </strong>
                <strong style="color: #F4B838;">
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription_International_Language" | translate }}.
                </strong>
              }
          </div>
          <div class="alert alert-primary border-alert-ct d-flex">
            <div class="fa-stack pe-3">
              <i class="fa-regular fa-circle fa-stack-2x"></i>
              <i class="fa-solid fa-info fa-stack-1x"></i>
            </div>
            <div class="ps-3">

              @if (showInternational == "International") {
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription_International" | translate }}
                <strong style="color: #F4B838;">
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription_International_Language" | translate }}.
                </strong><br>
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription_International_1" | translate }}&nbsp;
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription_1" | translate }}
              } @else {              
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription" | translate }}&nbsp;
                {{ "DCO.ClaimsClient_DisputeManagementInfo_PageDescription_1" | translate }}
              }

            </div>
          </div>
          <div *ngIf="confirmDisputP == true">
            <DCO-dynamic-form (confirmDisputeEvent)="receriveDisputeAct($event)"
              [isMassive]="isMassive"
              [claimOperationId]="claimOperationId"
              [claimOperationIds]="claimOperationIds"
              [dynamicFormId]="dynamicFormId"
              [requiredDocuments]="requiredDocuments"
              [formData]="formData"
              [fileRefs]="fileRefs"
              [finalStateDyf]="finalStateDyf"
              [comments]="comments"
              class="full-width">
            </DCO-dynamic-form>
          </div>
          <div class="mb-3"
            *ngIf="requiredDocuments && requiredDocuments.length > 0 && (myFormGroup?.documentsRequired ?? true)">
            <h6 class="text-primary mb-0">
              {{ "DCO.Disputes_RequiredDocumentation" | translate }}
            </h6>
            <p class="text-muted mt-2">{{ "DCO.Disputes_RequiredDocumentationInfo" | translate }}
              <!-- Documentación necesaria y recomendada para alegar este tipo concreto de disputa -->
            </p>
            <div class="table-responsive mt-1 mb-3">
              <table class="table table-hover order-table">
                <thead>
                  <tr>
                    <th>{{ "DCO.ClaimsClientDocumentation_Description" | translate }}</th>
                    <th class="text-center">{{ "DCO.ClaimsClientDocumentation_Status" | translate }}</th>
                    <th class="text-center">{{ "DCO.ClaimsClientDocumentation_Requirement" | translate }}</th>
                    <th class="text-center">{{ "DCO.ClaimsClientDocumentation_Selected" | translate }}</th>
                    <th class="text-center">{{ "DCO.ClaimsClientDocumentation_Actions" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-template #empty>
                    <tr>
                      <td colspan="5"
                        class="fw-semibold">
                        {{ "DCO.DisputesManagement_NoDocuments" | translate }}
                      </td>
                    </tr>
                  </ng-template>

                  <ng-container *ngIf="requiredDocuments && requiredDocuments.length > 0; else empty">
                    <tr *ngFor="let requiredDocument of requiredDocuments; index as i;let last = last">

                      <td class="fw-semibold">
                        {{ 'DCO.DisputesManagement_Document_' + requiredDocument.type | translate }}
                      </td>

                      <td class="text-center fw-semibold">
                        <ng-container *ngIf="requiredDocument.received; else adjuntado">
                          {{ "DCO.DisputesManagement_Received" | translate }}
                        </ng-container>
                        <ng-template #adjuntado>
                          <span
                            *ngIf="requiredDocuments && requiredDocuments[i] != undefined && requiredDocuments[i].uploaded; else pendiente"
                            class="text-success">
                            {{ "DCO.DisputesManagement_Attached" | translate }}
                          </span>
                        </ng-template>
                        <ng-template #pendiente>
                          <span class="text-warning">{{ "DCO.DisputesManagement_Pending" | translate }}</span>
                        </ng-template>
                      </td>

                      <td class="text-center">
                        <span [class]="requiredDocument.required ? 'text-danger' : 'text-info'">
                          {{ (requiredDocument.required ? "DCO.DisputesManagement_Required" :
                          "DCO.DisputesManagement_NotRequired") | translate }}
                        </span>
                      </td>
                      <td style="min-width: 180px;">
                        <div
                          *ngIf="!requiredDocuments[i].IsUploadedTrue && (commerceFilesByType[requiredDocuments[i].type]?.length > 0)">
                          <select class="form-select form-select-sm"
                            [(ngModel)]="requiredDocuments[i].id"
                            (ngModelChange)="SelectedDll(i, $event)">
                            <option value="0"
                              disabled>
                              {{ "DCO.DisputesManagement_SelectValue" | translate }}
                            </option>
                            <option *ngFor="let doc of commerceFilesByType[requiredDocuments[i].type] || []"
                              [value]="doc.commerceFileId">
                              {{ doc.fileName }}
                            </option>
                          </select>
                        </div>
                        <span *ngIf="requiredDocuments[i].IsUploadedTrue"
                          class="text-muted small">
                          {{ requiredDocuments[i].name }}
                        </span>
                      </td>

                      <td class="text-center">
                        <div class="d-flex align-items-center justify-content-center gap-2">

                          <button *ngIf="!requiredDocuments[i].IsUploadedTrue && !requiredDocuments[i].IsCommerceFile"
                            class="btn btn-link p-0"
                            type="button"
                            (click)="modalFileInput.click(); getIndex(i)">
                            <i class="fa-solid fa-paperclip fa-lg text-primary"></i>
                          </button>

                          <button *ngIf="requiredDocuments[i].IsUploadedTrue && requiredDocuments[i].IsCommerceFile"
                            class="btn btn-link p-0"
                            (click)="downloadCommerceFile(requiredDocument.id)">
                            <i class="fas fa-download text-primary fa-lg"></i>
                          </button>

                          <button *ngIf="requiredDocuments[i].IsUploadedTrue  && requiredDocuments[i].documentType"
                            class="btn btn-link p-0"
                            type="button"
                            (click)="viewDocument(i)"
                            title="Visualizar documento">
                            <i class="fas fa-download text-primary fa-lg"></i>
                          </button>

                          <button *ngIf="requiredDocuments[i].IsUploadedTrue"
                            class="btn btn-link p-0"
                            (click)="removeSelected(i)">
                            <i class="fa fa-trash-can text-danger fa-lg"></i>
                          </button>

                          <input type="file"
                            #modalFileInput
                            [attr.multiple]="requiredDocument.type=='OTHER_DOCUMENTS' ? '' : null"
                            class="d-none"
                            (change)="onModalDocumentUpload($event)" />
                          @if(last){
                          <button class="btn btn-secondary btn-sm rounded-2"
                            (click)="AddNewOtherDocumentLine()">
                            <i class="fa fa-plus"></i>
                          </button>
                          }
                        </div>

                      </td>

                    </tr>
                  </ng-container>
                </tbody>
              </table>

            </div>
            <div *ngIf="myFormGroup?.showRequiredDocuments ?? false"
              class="alert alert-danger">
              {{"DCO.MassiveInformation_DocumentsRequired" | translate}}
            </div>
          </div>

          <div class="d-flex  justify-content-end">
            <div>
              <button class="btn btn-outline-primary"
                (click)="onSave()">
                <div>{{"DCO.MassiveInformation_SaveData" |
                  translate}}</div>
              </button>
              <button type="button"
                class="btn btn-outline-secondary"
                data-bs-dismiss="modal"
                (click)="onCancel()">
                {{"DCO.MassiveInformation_Cancel" | translate}}
              </button>
            </div>
            <div>
              <button class="btn btn-primary"
                [disabled]="myFormGroup?.blockButton ?? false"
                (click)="onSubmit()">
                <div *ngIf="!(myFormGroup?.blockButton  ?? false); else spinner">{{"DCO.MassiveInformation_SaveForm" |
                  translate}}</div>
              </button>
              <ng-template #spinner>
                <div class="spinner-border spinner-border-sm"></div>
              </ng-template>
            </div>
          </div>
        </div>

    </div>
  </div>

